var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wave",rawName:"v-wave"}],staticClass:"fmButton",class:{ large: _vm.size === 'large', disabled: _vm.disabled },on:{"click":function($event){return _vm.onClick()}}},[_vm._t("default",[_vm._v(" No slot ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }